<template>
  <div>
    <el-row
      v-if="bulkProgress.isRunning"
      :gutter="20"
    >
      <el-col :span="24">
        <!-- A caller may draw the progress itself, from the same counters. -->
        <slot
          name="progress"
          :completed="bulkProgress.completed"
          :total="total"
          :percentage="progressPercentage"
        >
          <el-progress
            :text-inside="true"
            :stroke-width="20"
            :percentage="progressPercentage"
          />
        </slot>
      </el-col>
    </el-row>

    <el-row
      class="bulk-progress"
      v-if="bulkProgress.showResults && !hideResults"
      :gutter="20"
    >
      <el-col :span="24">
        <p class="bulk-progress__title">
          <strong>{{
            $t('analysesStatusManagement.groupingStatus.results')
          }}</strong>
        </p>
        <p>
          {{ $t('analysesStatusManagement.groupingStatus.completedNoErrors') }}
          {{ bulkProgress.completed - bulkProgress.errors.length }}
        </p>
        <div v-if="bulkProgress.errors.length > 0">
          <p class="bulk-progress__title">
            <strong>{{
              $t('analysesStatusManagement.groupingStatus.errors')
            }}</strong>
          </p>
          <p
            class="bulk-progress__error"
            v-for="(error, index) in bulkProgress.errors"
            :key="index"
          >
            {{ error }}
          </p>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  const defaultData = {
    action: null,
    actionReason: '',
  };

  export default {
    name: 'BulkCall',
    components: {},
    props: {
      function: { type: Function, required: true },
      arguments: { type: Array, required: true },
      // For a caller that shows the outcome itself, from `callCompleted`.
      hideResults: { type: Boolean, default: false },
    },
    data() {
      return {
        formData: { ...defaultData },
        bulkProgress: {
          completed: 0,
          errors: [],
          isRunning: false,
          showResults: false,
        },
      };
    },
    computed: {
      progressPercentage() {
        if (this.bulkProgress.completed > 0 && this.total > 0) {
          // Until run() resets them, the counters of the previous run may
          // exceed new, shorter arguments.
          return Math.min(
            100,
            Math.round((this.bulkProgress.completed / this.total) * 100)
          );
        }
        return 0;
      },
      total() {
        return this.arguments.length;
      },
      showResults() {
        return this.bulkProgress.completed === this.total;
      },
    },
    created() {},
    methods: {
      async run() {
        // A second click must not start a parallel loop over the same arguments
        if (this.bulkProgress.isRunning) return;

        this.bulkProgress.completed = 0;
        this.bulkProgress.errors = [];
        this.bulkProgress.showResults = false;
        this.bulkProgress.isRunning = true;

        // NEEDED
        // eslint-disable-next-line no-restricted-syntax
        for (const [index, args] of this.arguments.entries()) {
          try {
            // eslint-disable-next-line no-await-in-loop
            const response = await this.function.call(this, ...args);
            this.bulkProgress.completed += 1;
            const errors = response?.data?.errors || [];
            this.bulkProgress.errors.push(...errors);
            this.$emit('callCompleted', {
              index,
              error: errors.length ? errors.join('; ') : null,
            });
          } catch (error) {
            this.bulkProgress.completed += 1;
            // Without a response (network down) the client message: only the
            // caller of `callCompleted` sees it, the list stays as it was.
            const message = error.response?.data?.error?.message;
            if (error.response)
              this.bulkProgress.errors.push(message || error.message);
            this.$emit('callCompleted', {
              index,
              error: message || error.message,
            });
          }
        }
        this.bulkProgress.isRunning = false;
        this.bulkProgress.showResults = true;
        this.$emit('completed', this.bulkProgress.errors.length > 0);
      },
    },
  };
</script>

<style lang="scss"></style>
